<dgx-search-landing-page
  [title]="i18n.Core_Groups"
  [isLoading]="!hasError && !(data | async)"
  [hasError]="hasError"
  [results]="(data | async)?.groups"
  [totalNumResults]="(data | async)?.total"
  [hideOrgSelector]="true"
  [hideFilters]="true"
  [searchOrigin]="searchOrigin"
  [suggestionSource]="suggestionSource"
  [showSearchTabs]="showSearchTabs"
  (searchTerm)="search($event)"
>
  <ul id="results" class="grid">
    <li
      *ngFor="let item of (data | async)?.groups"
      class="grid__col-xs-6 grid__col-sm-4 grid__col-lg-3"
      data-dgat="search-groups-view-0cd"
    >
      <div class="tile__wrapper" data-dgat="search-groups-view-4e8">
        <dgx-group-tile [group]="item"></dgx-group-tile>
      </div>
    </li>
  </ul>
</dgx-search-landing-page>
